import { render, staticRenderFns } from "./vipInfo.vue?vue&type=template&id=b155efe2&"
import script from "./vipInfo.vue?vue&type=script&lang=js&"
export * from "./vipInfo.vue?vue&type=script&lang=js&"
import style0 from "./vipInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports